import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import trTranslations from './locales/tr.json';
import enTranslations from './locales/en.json';

// localStorage'dan dil tercihini oku
const getStoredLanguage = (): string => {
  try {
    const stored = localStorage.getItem('smartpm-language');
    if (stored && (stored === 'tr' || stored === 'en')) {
      return stored;
    }
  } catch (error) {
    console.error('Error reading language from localStorage:', error);
  }
  return 'tr'; // Varsayılan dil
};

const storedLanguage = getStoredLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      tr: {
        translation: trTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    lng: storedLanguage, // localStorage'dan okunan dil
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false, // React zaten XSS koruması sağlıyor
    },
  });

export default i18n;

